const currencySuffix = {
  BRL: '',
  PEN: '',
  COP: 'COP',
  USD: 'USD',
};

export default currencySuffix;
